import {
  APIs,
  API_BASE_URL,
  SERVICEURL,
  VDCLIMS,
  SHARED_SERVICEURL,
  REPORTDONESTATUS,
} from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

export const getPatientReportData = async (patientId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETPATIENTREPORT,
      {
        data: {
          patientId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStorageKeyFistolugram = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETFISTOLUGRAM,
      {
        data: {
          studyId: id,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const downloadFistolugramImage = async (fileName) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.DOWNLOADFISTOLUGRAM,
      {
        data: {
          filePath: fileName,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200) {
      const image = new Image();
      image.src = "data:image/jpg;base64," + response.data.data.data;
      const link = document.createElement("a");
      link.href = "data:image/jpg;base64," + response.data.data.data;
      link.download = "image.jpg";
      link.appendChild(image);
      const tempDiv = document.createElement("div");
      tempDiv.style.display = "none";
      tempDiv.appendChild(link);
      document.body.appendChild(tempDiv);
      link.click();
      document.body.removeChild(tempDiv);
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const uploadFistolugramService = async (id, file) => {
  var formData = new FormData();

  if (id != null) {
    const blob2 = new Blob([id], {
      type: "application/json",
    });
    formData.append("studyId", blob2);
  }
  formData.append("file", file);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.UPLOADFISTOLUGRAM,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getStudyReportData = async (studyId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETSTUDYREPORT,
      {
        data: {
          studyId,
          firmId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getS10ReportData = async (studyId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETS10REPORT,
      {
        data: {
          studyId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getReportTemplatesData = async (studyId,firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETREPORTTEMPLATE,
      {
        data: {
          studyId: studyId,
          firmId: firmId
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const downloadPdfReport = async (studyId, type) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.DOWNLOADREPORT + type,
      {
        data: {
          studyId: studyId,
        },
      }
    );
    if (
      response.status === 200 &&
      response.data.data.paymentStatus === VDCLIMS.PaymentStatusCodes.PAID
    ) {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData]);
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.data.filename);
      document.body.appendChild(link);
      link.click();
    }
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

/* Author: Tushar Saxena
   Description: Function to call API for downloading AI report
   Date: 02-02-2024
*/ 
export const downloadAIReportAPI = async (studyId) => {
  console.log("Calling API for download AI report");
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.DOWNLOADAIREPORT,
      {
        data: {
          studyId: studyId,
        },
      }
    );
    console.log("Response from download AI report", response);
    if (
      response.status === 200) {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData]);
      const url = window.URL.createObjectURL(file);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", response.data.data.filename);
      document.body.appendChild(link);
      link.click();
    }
    return response;
  } catch (error) {
    console.log(error);
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const previewPdfReport = async (studyId, reportDoneStatus) => {
  try {
    const response = await axiosInterceptor.post(
     API_BASE_URL + APIs.PREVIEWREPORT,
      {
        data: {
          studyId: studyId,
        },
      }
    );
    if (
      response.status === 200 &&
      response.data.result === "SUCCESS" &&
      (reportDoneStatus === REPORTDONESTATUS.SAVED || response.data.data.paymentStatus === VDCLIMS.PaymentStatusCodes.PAID)
    ) {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(
        url, 
        "_blank", 
       `width=${window.innerWidth},height=${window.innerHeight},left=0,top=0,location=no,scrollbars=yes`
      );
      /*
      if (newWindow) {
        newWindow.document.write('<html><body style="margin:0; padding:0; height:100%;">');
        newWindow.document.write('<iframe src="' + url + '" width="100%" height="100%" style="border:none; margin:0; padding:0;"></iframe>');
        newWindow.document.write('</body></html>');
        newWindow.document.close(); // Close the document to render it
      } */
    }

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const previewWordHistoryPdfReport = async (reportHistoryId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.PREVIEWWORDREPORTHISTORY,
      {
        data: {
          reportHistoryId: reportHistoryId,
        },
      }
    );
    console.log(response);
    if (
      response.status === 200 &&
      response.data.result === "SUCCESS" 
    ) {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(url, "_blank", "width=600,height=700,location=no");
    }

    return response;
  } catch (error) {
    console.log("error ", error);
    // if (error.response.status === 403)
    //   window.location.assign(APIs.REDIRECTLOGOUT);
    // else return error.response;
  }
};

export const previewPdfReportVersion = async (versionId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.PREVIEWREPORTVERSION,
      {
        data: {
          versionId: versionId,
        },
      }
    );
    if (response.status === 200 && response.data.result === "SUCCESS") {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.open(url, "_blank", "width=600,height=700,location=no");
    }

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const saveReportTemplatesData = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SAVEREPORT,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const submitReportTemplatesData = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.SUBMITREPORT,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getAllPathologies = async (studyId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETALLPATHOLOGY,
      {
        data: {
          studyId: studyId,
          firmId
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getSelectedPathologies = async (studyId, activeData) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + APIs.GETSELECTEDPATHOLOGY,
      {
        data: {
          studyId: studyId,
          activeData
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const assignStudy = async (isAssign, body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.ASSIGNSTUDY,
      {
        data: {
          isAssign: isAssign,
          reportingProvider: body,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const regenerateReport = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.REGENERATEREPORT,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateRSNADynamicReport = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.GENERATERSNAREPORT,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateCTBrainReportCall = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.GENERATECTBRAIN,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const generateMRISpineReportCall = async (body) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.GENERATERSNAREPORT,
      {
        data: body,
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getHTMLTemplate = async (id) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.GETHTMLTEMPLATE,
      {
        data: {
          reportTemplateId: id,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const submitQC = async (qcReviewDto, allTextToolData) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.QCPASS,
      {
        data: {
          qcReviewDto,
          allTextToolData,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const getQCProvidersList = async (clientProvidersMapping) => {
  try {
    const response = await axiosInterceptor.post(
      // API_BASE_URL + SERVICEURL + APIs.GETSTUDYDATA,
      API_BASE_URL + SERVICEURL + APIs.QCPROVIDERLIST,
      {
        data: {
          clientProvidersMapping,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const viewPdfReport = async (payload) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SHARED_SERVICEURL + APIs.VIEWREPORT,
      {
        data: payload,
      }
    );
    if (response.status === 200 && response.data.result === "SUCCESS") {
      const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
      const file = new Blob([fileData], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      window.location.href = url;
    }

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const markAsSuspect = async (studyId, firmId) => {
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.MARKEDASSUSPECT,
      {
        data: {
          studyId,
          firmId,
        },
      },
      {
        headers: {
          "content-type": "application/json",
        },
      }
    );
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
// export const downloadDoc = async (studyId) => {
//   var wordBaseURL= API_BASE_URL;
//   if( process.env.REACT_APP_HYBRID_MODE == "false"){
//     wordBaseURL= wordBaseURL + SHARED_SERVICEURL+"/" 
//   }
//   var wordDocUrl = wordBaseURL +"ms-word/download/doc/" + studyId + ".docx";
//   try {
//     const response = await axiosInterceptor.get(
//       API_BASE_URL + SERVICEURL + "/ms-word/getStudyReportTemplate/" + studyId
//     );
//     if (response.status === 200) {
//       const fileData = _base64ToArrayBuffer(response.data.data.byteArray);
//       const file = new Blob([fileData]);
//       const url = window.URL.createObjectURL(file);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", "StudyReportTemplate.json");
//       document.body.appendChild(link);
//       link.click();
//     }
//     // saveAs(
//     //   new File([JSON.stringify(response.data)], "StudyReportTemplate.json", {
//     //     type: "text/plain;charset=utf-8",
//     //   }));

//     var wordInstance = document.createElement("a");
//     wordInstance.id = "lnkMsWord";
//     var link = document.createTextNode("word link");
//     wordInstance.appendChild(link);
//     wordInstance.title = "ms-word";
//     wordInstance.href = "ms-word:ofe|u|" + wordDocUrl;
//     wordInstance.click();
//   } catch (error) {
//     if (error.response.status === 403)
//       window.location.assign(APIs.REDIRECTLOGOUT);
//     else return error.response;
//   }
// };

export const getWordSession= async (studyId)=>{
  try{
    const response = await axiosInterceptor.get(
      API_BASE_URL + SERVICEURL + APIs.GETWORDSESSION +'/' + studyId
    );
    return response;
  }catch(error){
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};


export const directReportSubmit = async(studyId) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + SERVICEURL + "/study/report/api/nidanpathologyfinalreportsubmit", {
      data: {
        studyReportSaveDto: {
          id: studyId,
          conflictSave: 1
        }
      }
    })

    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};

export const addClientReportRestriction= async (body)=>{
  try{
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.ADDREPORTTEMPLATERESTRICTIONS,
      {
        data: body
      }
    );
    return response;
  }catch(error){
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const getModalityListForRestriction = async(firmId, clientId) =>{
  try{
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.MODALITYLISTFORRESTRICTION,
      {
        data: {
          "firmId": firmId,
          "clientId": clientId
        }
      }
    );
    return response;
  }catch(error){
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const regenerateLLMReport = async(llmReportDto) => {
  console.log("llm report dto : ", llmReportDto);
  try {
    const response = await axiosInterceptor.post(
      API_BASE_URL + SERVICEURL + APIs.REGENERATELLMREPORT, {
        data: {
          llmReportDto
        }
      }
    )
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
}

export const getFormattedReport = async (body) => {
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + SERVICEURL + APIs.GETFORMATTEDREPORT, {
      data: body,
    });
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
